module.exports = __webpack_public_path__ + "img/characterAnime18.88683ab9.png";